module.exports = __webpack_public_path__ + "img/suitcase-icon.d0af9dc5.svg";